import {
    ForbiddenError,
    RequestError,
    ServerError,
    UnauthorizedError,
    UnexpectedHttpError
} from "@web-libs/core/http/api/http.errors";

export const handleError = (error: unknown) => {
    if (error instanceof FetchStatusError) {
        handleFetchStatusError(error);
    } else if (error instanceof Error) {
        handleGenericError(error);
    } else if (typeof error === 'string') {
        handleStringError(error);
    } else {
        handleUnknownError(error);
    }
}

const handleFetchStatusError = (error: FetchStatusError) => {
    if(UnauthorizedError.isUnauthorizedError(error.status)) {
        throw new UnauthorizedError();
    }
    if(ForbiddenError.isForbiddenError(error.status)) {
        throw new ForbiddenError();
    }
    if(RequestError.isRequestError(error.status)) {
        throw new RequestError("Request error with status: " + error.status + " and message: " + error.message, error.message, error.status);
    } else if(ServerError.isServerError(error.status)) {
        // Server error warning removed
    }
}

const handleGenericError = (error: Error) => {
    throw UnexpectedHttpError.fromError(error);
}

const handleStringError = (error: string) => {
    throw new UnexpectedHttpError(error);
}

const handleUnknownError = (error: unknown) => {
    console.error(error);
    throw new UnexpectedHttpError('Unknown error');
}


export class FetchStatusError extends Error {
    constructor(public status:number, message?: string) {
        super(message);
        this.name = 'FetchStatusError';
        Object.setPrototypeOf(this, FetchStatusError.prototype);
    }
}
